import React,{Fragment, useState, useEffect} from "react";
import Navbar  from "../Navbar";
import Footer  from "../Footer";
import { useTranslation } from "react-i18next";
import { Container, Form, Row, Col, Button, CardBody } from "react-bootstrap";
import Cookies from 'js-cookie';
import MedicalDownload from './Mednet_network_list.xlsx';
import  Table_Of_Benifits from './Download_Table_Of_Benifits.pdf';
import Download_Exclusion_List from './Download_Exclusion_List.pdf';
import Download_Policy_Wording from './Download_Policy_Wording.pdf';
import Download_Covid_terms_and_condition from './Download_Covid-19_terms_and_condition.pdf';
const { config } = require('../api/api');

function MedicalSumAssured(){
  const base_url = config.baseURL;

    const lnstr = Cookies.get('langData') ? Cookies.get('langData') : 'en';

    const { t } = useTranslation();
    const [greenplan, setGreenplan] = useState('');
    const [silverplan, setSilverPlan] = useState('');
    const [goldplan, setGold] = useState('');
    const [fullvalue, setFullvalue] = useState([]);
    const [assured, setAssuredvalue] = useState(null);
    const [color , setColor] = useState('')


    const [selectedColorPlan, setSelectedColorPlan] = useState('');
    const [selectedPlanLimits, setSelectedPlanLimits] = useState(null);
    const [showbutton1 , setShowbutton1] = useState(true)
    const [showbutton2 , setShowbutton2] = useState(true)
    const [showbutton3 , setShowbutton3] = useState(true)


    const [selectedAnnualLimit, setSelectedAnnualLimit] = useState( selectedPlanLimits?.annual_limits?.[0] || '');
    const [selectedOutPatient, setSelectedOutPatient] = useState(selectedPlanLimits?.out_patient?.[0] || '');
    const [selectedCoPay, setSelectedCoPay] = useState(selectedPlanLimits?.co_pays?.[0] || '');
  

  const [vendorKey, setVendorKey] = useState('');
  
const [docUrls, setDocUrls] = useState({});
    useEffect(() => {
      const docs = ['table-of-benefits', 'network-list', 'covid-19-terms-and-conditions', 'policy-exclusion'];
      docs.forEach(file => {
        fetch(base_url + '/getdhofarpolicydocument?file=' + file)
          .then(r => r.json())
          .then(d => setDocUrls(prev => ({ ...prev, [file]: d.data })))
          .catch(() => {});
      });
    }, []);
    useEffect(() => {
  
      const postvData = { organization_name: "Superjet" };
  
      if (vendorKey === '' || vendorKey === null || vendorKey === undefined) {
  
  
        fetch( base_url + '/create_organization', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(postvData),
        })
          .then(response => response.json())
          .then(data => {
            setVendorKey(data.result[0].vendor_key);
          })
          .catch(error => {
            console.error('Error posting data:', error);
          });
  
  
      }
    }, [vendorKey]);

    const [dhofarData, setDhofarData] = useState(false);
  const [age, setAge] = useState(null);
  useEffect(() => {


    const storedDhofarString = Cookies.get('HealthIndividualData'); //sessionStorage.getItem('userData')
    if (storedDhofarString !== undefined) {
      const storedDhofar = JSON.parse(storedDhofarString);
      setDhofarData(storedDhofar);
    }
    else {
      // alert("token expired");
      // window.location.href='/';
    }

  }, []);

  const Individualvaluejson = sessionStorage.getItem('mediindivialbasicinfo');
  const Individualvalue = JSON.parse(Individualvaluejson)
  console.log(Individualvalue)

  function formatDOB(dob) {
    const date = new Date(dob);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }
//   const [buttonDisabled, setButtonDisabled] = useState(false);
  const postData = { token: dhofarData };

    // const items =[{ amount: '24.000 ', description: ' 5,000' , plan : 'Green' },
    //     { amount: '15.000 ', description: ' 3,000' , plan : 'Silver' },
    //     { amount: '10.000 ', description: ' 1,000' , plan : 'Gold' },];

    const handleSubmit = async (event) => {

            event.preventDefault();
            setLoading(true);
debugger
            var data = {
              "color":selectedColorPlan,
              "assuredvalue": assured,
              "annuallimit": selectedAnnualLimit,
              "outpatient":selectedOutPatient,
              "copay": selectedCoPay
            }
            sessionStorage.setItem("premiumfullvalue" , JSON.stringify(data))
            
            event.preventDefault();
            window.location.href='/medical-plan';
          };
    const [buttonDisabled, setButtonDisabled] = useState(false);

    const [loading, setLoading] = useState(false);


  useEffect(() => {
    const value_data ={
      'token':dhofarData,
      'dob': formatDOB(Individualvalue.dob),
      'gender':Individualvalue.basicinfo_gender_detail.toLowerCase(),
      'married':Individualvalue.basicinfo_marital_status_detail.toLowerCase() === "single" ? 'no' : 'yes',
    }
    debugger

    if (vendorKey !== '') {
      fetch( base_url + '/get_him_premiums', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${vendorKey}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(value_data),

      })
        .then(response => response.json())
        .then(data => {
          debugger
          const greens = data.result.data.green;
          const silvers = data.result.data.silver;
          const golds = data.result.data.gold;
          setGreenplan({ premium: Math.min(...greens.map(p => parseFloat(p.premium))).toFixed(2) });
          setSilverPlan({ premium: Math.min(...silvers.map(p => parseFloat(p.premium))).toFixed(2) });
          setGold({ premium: Math.min(...golds.map(p => parseFloat(p.premium))).toFixed(2) });
        })
        .catch(error => {
          console.error('Error posting data:', error);
        });

    }
  }, [vendorKey]
  );





  //

  const [isOpen, setIsOpen] = useState(false);

  const togglePopup = () => {
    debugger
      setIsOpen(!isOpen);
  };
  const getPlanLimitsDetails = (color_plan) => {
    setSelectedColorPlan(color_plan);
    return getfullPlansDetails(color_plan);
  }


  const getfullPlansDetails = (color_plan) => {
    setSelectedColorPlan(color_plan);

    const value_data = {
      'token':dhofarData,
      'dob': formatDOB(Individualvalue.dob),
      'gender':Individualvalue.basicinfo_gender_detail.toLowerCase(),
      'married':Individualvalue.basicinfo_marital_status_detail.toLowerCase() === "single" ? 'no' : 'yes',
    }
    return fetch( base_url + '/get_him_premiums', {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${vendorKey}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(value_data),
    })
      .then(response => response.json())
      .then(data => {
        const plans = data?.result?.data[color_plan] || [];
        setFullvalue(plans);

        const annualLimits = [...new Set(plans.map(p => p['annual-limit']))].sort((a, b) => a - b);
        const outPatients  = [...new Set(plans.map(p => p['out-patient']))].sort((a, b) => a - b);
        const coPays       = [...new Set(plans.map(p => p['co-pays']))].sort((a, b) => a - b);

        const planLimits = { annual_limits: annualLimits, out_patient: outPatients, co_pays: coPays };
        setSelectedPlanLimits(planLimits);
        setSelectedAnnualLimit(annualLimits[0] || '');
        setSelectedOutPatient(outPatients[0] || '');
        setSelectedCoPay(coPays[0] || '');
      })
      .catch(error => {
        console.error('Error posting data:', error);
      });
  }



  useEffect(() => {
    if (!fullvalue || fullvalue.length === 0) return;
    const matchingPlan = fullvalue.find(plan =>
      plan["annual-limit"] === selectedAnnualLimit &&
      plan["co-pays"] === selectedCoPay &&
      plan["out-patient"] === selectedOutPatient
    );
    setAssuredvalue(matchingPlan ? matchingPlan.premium : null);
  }, [fullvalue, selectedAnnualLimit, selectedCoPay, selectedOutPatient]);

  const Popup = ({ onClose }) => {

    return (
      
      <div style={popupStyle}  className="popup-container p-3" >

    <h4 className="px-0 py-2 text-center">{(lnstr === 'en') ? 'Choose your limits' : 'اختر حدودك\n'}</h4>

<form>

<div className="d-flex justify-content-between my-3 colmds-4 card m-0">
<div className="d-lg-flex justify-content-between my-1">
  <div>
  <h3><strong>{selectedColorPlan.toUpperCase()}</strong></h3>
  <p><strong>{t("See")} {t("Details")}</strong></p>
  </div>
  <div>
<h1>{assured ?? '-'} OMR</h1>
</div>

</div>
</div>
{/* <div> */}

<div>
<div className="my-3">
            <h4>{lnstr === 'en' ? 'Annual Limit' : 'المبلغ المؤمن'}</h4>
            <div className="pl-3">
              {selectedPlanLimits?.annual_limits?.map((limit, index) => (
                <div key={index} className="d-flex align-items-center my-2">
                  <input
                    style={{ marginRight: '10px' , marginBottom: '7px' }}
                    type="radio"
                    id={`annual_limit_${index}`}
                    name="annual_limit"
                    value={limit}
                    checked={selectedAnnualLimit === limit}
                    onChange={(e) => setSelectedAnnualLimit(e.target.value)}
                  />
                  <label htmlFor={`annual_limit_${index}`}  style={{ fontSize: '16px' }}>{limit}</label>
                </div>
              ))}
            </div>
          </div>

          {/* Out Patient Deductible Section */}
          <div className="my-3">
            <h4>{lnstr === 'en' ? 'Op Deductible' : 'المرجع للخصم'}</h4>
            <div className="pl-3">
              {selectedPlanLimits?.out_patient?.map((out, index) => (
                <div key={index} className="d-flex align-items-center my-2">
                  <input
                    style={{ marginRight: '10px', marginBottom:'7px' }}
                    type="radio"
                    id={`out_patient_${index}`}
                    name="out_patient"
                    value={out}
                    checked={selectedOutPatient === out}
                    onChange={(e) => setSelectedOutPatient(e.target.value)}
                  />
                  <label htmlFor={`out_patient_${index}`} style={{ fontSize: '16px' }}>{out}</label>
                </div>
              ))}
            </div>
          </div>
          {/* Co-Pay Section */}
          <div className="my-3">
            <h4>{lnstr === 'en' ? 'PM Co Pay' : 'PM Co الدفع'}</h4>
            <div className="pl-3">
              {selectedPlanLimits?.co_pays?.map((copay, index) => (
                <div key={index} className="d-flex align-items-center my-2">
                  <input
                    style={{ marginRight: '10px', marginBottom: '7px' }}
                    type="radio"
                    id={`copay_${index}`}
                    name="copay"
                    value={copay}
                    checked={selectedCoPay === copay}
                    onChange={(e) => setSelectedCoPay(e.target.value)}
                  />
                  <label htmlFor={`copay_${index}`} style={{ fontSize: '16px' }}>{copay}</label>
                </div>
              ))}
            </div>
          </div>
        </div>
        {/* Action Buttons Section */}
        <div className="d-flex flex-column flex-sm-row justify-content-between my-3">
          <button
            type="button"
            disabled={buttonDisabled}
            onClick={() => {
              onClose();
              setShowbutton1(true);
              setShowbutton2(true);
              setShowbutton3(true);
            }}
            className="btn btn-primary rounded-pill text-white my-1 py-1 px-4"
          >
            {t('Cancel')}
          </button>
          <button
            type="submit"
            disabled={buttonDisabled}
            onClick={handleSubmit}
            className="btn btn-primary rounded-pill text-white my-1 py-1 px-4"
          >
            {t('Next')}
          </button>
        </div>


</form>

        </div>
        
    );
};

const popupStyle = {
    position: 'fixed',
    width:'35%',
    top: '50%',
    left: '48%',
    transform: 'translate(-50%, -50%)',
    padding: '20px',
    background: 'white',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
    zIndex: 1050,
    borderRadius: '8px',
};


const popupback = {
  position: "fixed",
  top: '50%',
  left: '50%',
  width: "40%",
  height: "100%",
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: "1000",
} 
    return(
        <Fragment>
            <div className="header_section1">
                <Navbar/>
                <div className="container-fluid bg-breadcrumb">
                    <div className="container text-center py-5">
                        <h3 className="abt-txt my-5">{(lnstr === 'en') ? 'Choose your Plan':'اختر خطتك'}</h3>
                    </div>
                </div>
            </div>

            <div className="features_sections"  style={{backgroundColor: isOpen ? "rgba(0, 0, 0, 0.5)" : "transparent", backdropFilter: isOpen ? "blur(5px)" : "none", zIndex: isOpen ? 1040 : "auto", 
        }}>
                <div className="container">
                    <div className="row">
                        <Col md={2}></Col>
                        <Col md={9} className="myforms my-5">
                        <ul style={{listStyle : 'Circle' , fontSize: '30px', margin:'13px'}}>
                          <li>
                            <div style = {{display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                              <div>
                             { lnstr=="en"?<p>Plan starting from</p>:<p>الخطة تبدأ من</p>}
                            <h1 className="text-bold"><strong>{greenplan.premium} {"OMR"}</strong></h1>
                            <h2 ><b>{lnstr=="en"?<u>GreenPlan</u>:<u>الخطة الخضراء</u>}</b></h2>
                            {lnstr=="en"?<p> Green Network with Annual Limit between 3,000 to 5,000 OMR</p>:<p>الشبكة الخضراء بحد سنوي يتراوح بين 3000 إلى 5000 ريال عماني</p>}
                              </div>

                              {showbutton1 && (

<div style = {{marginBottom:'110px' , marginRight: '90px'}}>
<button type="submit" disabled={buttonDisabled} onClick={async ()=>{
  setLoading(true);
  await getPlanLimitsDetails('green');
  setLoading(false);
  togglePopup();
  setShowbutton1(false)
  setShowbutton2(false)
  setShowbutton3(false)
}} className="btn btn-primary rounded-pill text-white my-1 py-1 px-4">{t('ADD')}</button>
</div>

                              )}
                            {/* <a herf ={MedicalDownload} download='Mednet network list.xlsx'>Download Network List</a> */}
                           
                            </div> 
                          </li>



                          <li>
                            <div style = {{display: "flex", justifyContent: "space-between", alignItems: "center" ,  flexDirection: 'row'}}>
                            <div>
                             { lnstr=="en"?<p>Plan starting from</p>:<p>الخطة تبدأ من</p>}
                            <h1 className="text-bold"><strong>{silverplan.premium} {"OMR"}</strong></h1>
                            <h2 ><b>{lnstr=="en"?<u>SilverPlan</u>:<u>الخطة الفضية</u>}</b></h2>
                           {lnstr=="en"? <p>Silver Network with Annual Limit between 3,000 to 10,000 OMR</p>:<p>الشبكة الفضية لها حد سنوي يتراوح ما بين 3000 إلى 10000 ريال عماني.</p>}
                            </div>

                            {showbutton2 && (

<div>
<button style={{marginRight:'90px'}} type="submit" disabled={buttonDisabled} onClick={async ()=>{
  setLoading(true);
  await getPlanLimitsDetails('silver');
  setLoading(false);
  togglePopup();
  setShowbutton1(false)
  setShowbutton2(false)
  setShowbutton3(false)
}}  className="btn btn-primary rounded-pill text-white my-1 py-1 px-4">{t('ADD')}</button>
</div>

                              )}

                            
                            {/* <a herf ={MedicalDownload} download='Mednet network list.xlsx'>Download Network List</a> */}
                            {/* <div style = {{marginBottom:'110px' , marginRight: '90px'}}  >
                           
                            </div> */}
                            </div>
                          </li>



                          <li>
                            <div style = {{display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                              <div>
                              { lnstr=="en"?<p>Plan starting from</p>:<p>الخطة تبدأ من</p>}
                            <h1 className="text-bold"><strong>{goldplan.premium} {"OMR"}</strong></h1>
                            <h2 ><b>{lnstr=="en"?<u>GoldPlan</u>:<u>الخطة الذهبية</u>}</b></h2>
                            {lnstr=="en"?<p>Gold Network with Annual Limit between 5,000 to 15,000 OMR</p>:<p>الشبكة الذهبية بحد سنوي يتراوح بين 5,000 إلى 15,000 ريال عماني</p>}
                              </div>

                              {showbutton3 && (

<div style = {{marginBottom:'110px' , marginRight: '90px'}}>
<button type="submit" disabled={buttonDisabled} onClick={async ()=>{
  setLoading(true);
  await getPlanLimitsDetails('gold');
  setLoading(false);
  togglePopup();
  setShowbutton1(false)
  setShowbutton2(false)
  setShowbutton3(false)
}} className="btn btn-primary rounded-pill text-white my-1 py-1 px-4">{t('ADD')}</button>
</div>

                              )}
                           
                            {/* <a herf ={MedicalDownload} download='Mednet network list.xlsx'>Download Network List</a> */}
                            </div>
                           <p>---------------------------------------------------------------------</p> 
                          </li>
                        </ul>
                       <div><i className="fas fa-chevron-right" style={{marginRight:'15px'}}></i><u><a href={docUrls['table-of-benefits']} target='_blank' rel='noreferrer'>{lnstr=="en"?<span>Download Table Of Benifits</span>:<span>تحميل جدول الفوائد</span>}</a></u></div> 
                       <div><i className="fas fa-chevron-right" style={{marginRight:'15px'}}></i><u><a href={docUrls['network-list']} target='_blank' rel='noreferrer'>{lnstr=="en"?<span>Download Network List</span>:<span>تحميل قائمة الشبكة</span>}</a></u></div>
                       <div><i className="fas fa-chevron-right" style={{marginRight:'15px'}}></i><u><a href={docUrls['covid-19-terms-and-conditions']} target='_blank' rel='noreferrer'>{lnstr=="en"?<span>Download Covid-19 terms and condition</span>:<span>تنزيل الشروط والأحكام الخاصة بكوفيد-19</span>}</a></u></div>
                       <div><i className="fas fa-chevron-right" style={{marginRight:'15px'}}></i><u><a href={docUrls['policy-exclusion']} target='_blank' rel='noreferrer'>{lnstr=="en"?<span>Download Exclusion List</span>:<span>تحميل قائمة الاستبعاد</span>}</a></u></div>
                                       
                        </Col>
                        <Col md={1}></Col>                        
                    </div>
                </div>

            {isOpen && <Popup onClose={togglePopup} />}
            </div>

            <Footer/>

            {loading && (
                <div className="overlay">
                <div className="spinner"></div>
                </div>
            )}
        </Fragment>

    );


}
export default MedicalSumAssured;